import React from 'react';
import useIntls from '@opm/hooks/useIntls';
import { DBO_V } from '@op/utils/format';
import './index.scss';

export interface IMetricsBarItem {
  key: string;
  label: string;
}

export interface IMetricsBarProps {
  /** Data record containing metric values */
  records: any;
  /** Metric columns to display */
  metrics?: IMetricsBarItem[];
  variant?: 'default' | 'grid';
}

/** Default metrics config */
const DEFAULT_METRICS: IMetricsBarItem[] = [
  { key: 'impression_number', label: 'Impressions' },
  { key: 'like_count', label: 'Likes' },
  { key: 'share_count', label: 'Shares' },
  { key: 'comment_count', label: 'Comments' },
];

/**
 * MetricsBar — reusable metrics display component
 * Used by both CardListView (bottom metrics) and TableView (body column)
 */
export default function MetricsBar({
  records,
  metrics = DEFAULT_METRICS,
  variant = 'default',
}: IMetricsBarProps) {
  const { intl } = useIntls();

  return (
    <div className={`dbom-metrics-bar dbom-metrics-bar--${variant}`}>
      {metrics.map((item, idx) => (
        <React.Fragment key={item.key}>
          {variant === 'default' && idx > 0 && (
            <span className="dbom-metrics-bar__sep" />
          )}
          {
            variant === 'default' ? (
              <div className="dbom-metrics-bar__item">
                <span className="dbom-metrics-bar__value">
                  {records[item.key] ? DBO_V.reviews(records[item.key]) : '-'}
                </span>
                <span className="dbom-metrics-bar__label">{intl(item.label)}</span>
              </div>
            ) : (
              <div className="dbom-metrics-bar__item">
                <span className="dbom-metrics-bar__label">{intl(item.label)}</span>
                <span className="dbom-metrics-bar__value">
                  {records[item.key] ? DBO_V.reviews(records[item.key]) : '-'}
                </span>
              </div>
            )
          }
        </React.Fragment>
      ))}
    </div>
  );
}
